<div class="flex gap-1rem">
  <div class="flex-direction-column">
    <span class="font-mobile color-primary">Tempo na Etapa</span>
    <span class="font-mobile">{{ sessao?.tempoEtapaAtual ?? '--' }} H</span>
  </div>
  <div class="flex-direction-column">
    <span class="font-mobile color-primary">Tempo de Finalização</span>
    <div>
      @if (sessao?.ativo && sessao?.dataFormatadaFinalizar && sessao?.dataFormatadaFinalizar !== '00:00') {
        <app-progress-bar-data
          [data]="sessao!.dataFormatadaFinalizar!"
          [tempoFinalizar]="sessao!.tempoFinalizar!"
          [verificaFinalizada]="true"
          [width]="'100%'"
          [height]="'5vw'"
          [font]="'clamp(11px, 3vw, 28px)'"
        >
        </app-progress-bar-data>
      }
      @else if (sessao?.ativo && sessao?.dataFormatadaFinalizar && sessao?.dataFormatadaFinalizar === '00:00') {
        <span>Finalizado</span>
      }
    </div>
  </div>
</div>
